import React from 'react';

const SaudiRiyalIcon = ({ width = 24, height = 24, fill = 'currentColor', ...props }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.3663 5.63343C14.0415 4.87558 14.4564 4.53534 15.2713 4.10518V16.7248L13.3663 17.1184V5.63343Z" fill="currentColor"/>
    <path d="M19.4529 11.978C19.8478 11.1444 19.8943 10.7739 20 9.91875L5.39805 13.0894C5.05179 13.8607 4.94033 14.2919 4.88696 15.0576L19.4529 11.978Z" fill="currentColor"/>
    <path d="M19.4529 15.8433C19.8478 15.0097 19.8943 14.6392 20 13.7841L13.436 15.1734C13.3896 15.9375 13.4429 16.3295 13.3896 17.0953L19.4529 15.8433Z" fill="currentColor"/>
    <path d="M19.4529 19.7081C19.8478 18.8745 19.8943 18.504 20 17.6489L14.0168 18.9477C13.7148 19.3645 13.5289 20.0592 13.3896 20.9601L19.4529 19.7081Z" fill="currentColor"/>
    <path d="M9.95136 18.392C10.5321 17.6742 11.1361 16.7711 11.5543 16.0301L4.51109 17.5568C4.16482 18.3281 4.05336 18.7592 4 19.525L9.95136 18.392Z" fill="currentColor"/>
    <path d="M9.64935 4.56829C10.3245 3.81044 10.7394 3.4702 11.5543 3.04004V16.0765L9.64935 16.4701V4.56829Z" fill="currentColor"/>
  </svg>
);

export default SaudiRiyalIcon;
